import { FetchFinCategoriesSortTypes } from './finCategoriesTypes';

export const INITIAL_FIN_CATEGORIES_FILTERS = {};
export const INITIAL_FIN_CATEGORIES_PAGE = 1;
export const INITIAL_FIN_CATEGORIES_SORT = [
  FetchFinCategoriesSortTypes.CREATED_AT_DESC
];
export const INITIAL_FIN_CATEGORIES_LIMIT = 100;

export const enum FinCategoriesPermissions {
  READ_FIN_CATEGORIES_INDEX_ES_QUERY = 'read_fin_categories_index_es_query'
}
